export default "assets/1623de835f1bd844d02c66406da131a3.png";